import { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  ModalCloseX,
  ModalHeading,
} from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { DateTimeDisplay } from "./DateTimeDisplay"
import {
  ActivityIcon,
  ActivityName,
} from "src/components/Activity"
import styles from "src/styles/entryModal.module.scss"
import type { ReadOnlyUserEvent } from "src/types"

interface Props {
  activityType: ActivityType;
  userEvent: ReadOnlyUserEvent;
  closeBtnId: string;
}

export function EventModalHeader(props: Props) {
  const {
    activityType, closeBtnId, userEvent,
  } = props

  const suspendReason = useMemo(
    () => userEvent.event_type === ActivityType.PumpSuspension ?
      userEvent.pump_suspension.suspend_reason : undefined,
    [userEvent],
  )

  return (
    <ModalHeading>
      <div className={styles.headerRow}>
        <ActivityIcon
          activityType={activityType}
          suspendReason={suspendReason}
          className={styles.activityIcon}
        />
        <div className={styles.headingContent}>
          <ActivityName
            activityType={activityType}
            suspendReason={suspendReason}
          />
          <DateTimeDisplay userEvent={userEvent} />
        </div>
      </div>
      <ModalCloseX
        id={closeBtnId}
      />
    </ModalHeading>
  )
}
